import { render, staticRenderFns } from "./ReportTransport.vue?vue&type=template&id=20aed7d5"
import script from "./ReportTransport.vue?vue&type=script&lang=js"
export * from "./ReportTransport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports